type PubNubHistoryFileMessage = {
  message: Record<string, unknown>;
  file: unknown;
};

function isHistoryFileMessage(
  value: unknown,
): value is PubNubHistoryFileMessage {
  if (typeof value !== 'object' || value === null) return false;
  const { message, file } = value as { message?: unknown; file?: unknown };
  return (
    !!file &&
    typeof message === 'object' &&
    message !== null &&
    !Array.isArray(message)
  );
}

/**
 * PubNub 履歴API(fetchMessages)の file メッセージは、送信時の message 本体が
 * { message: <本体>, file: { id, name } } と入れ子で返る（リアルタイムの file
 * イベントとは構造が異なる）。表示層は { text, file } のフラット形を前提に
 * text を解決するため、入れ子のままだと本文が表示されない。
 * 入れ子の場合だけ本体を展開して file を持ち上げ、それ以外はそのまま返す。
 */
export function flattenPubNubFileMessage(rawMessage: unknown): unknown {
  if (!isHistoryFileMessage(rawMessage)) return rawMessage;
  return { ...rawMessage.message, file: rawMessage.file };
}
